module.exports = __webpack_public_path__ + "assets/38811ef3109ea4eb6d14bfdc010f9bb8.mp3";